import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

export default function TrustBar() {
  const { t } = useTranslation();
  const FACTS: Array<{ value: string; label: string }> = [
    { value: "100%", label: t("trust.made_in_italy") },
    { value: "40+", label: t("trust.countries") },
    { value: "4 700", label: t("trust.partners") },
    { value: "1968", label: t("trust.since") },
  ];
  const ref = useRef<HTMLDivElement | null>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el || typeof window === "undefined" || !("IntersectionObserver" in window)) {
      setVisible(true);
      return;
    }
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          io.disconnect();
        }
      },
      { threshold: 0.3 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <section
      ref={ref}
      className="relative bg-[hsl(0_0%_7%)] text-white border-t border-white/5"
      aria-label="Brand facts"
    >
      <div className="lc-container-ext py-7 md:py-8">
        <ul className="grid grid-cols-2 md:grid-cols-4 gap-y-6 gap-x-8 items-center">
          {FACTS.map((f, i) => (
            <li
              key={f.label}
              className="flex flex-col md:flex-row md:items-baseline md:gap-3 transition-all duration-700"
              style={{
                opacity: visible ? 1 : 0,
                transform: visible ? "translateY(0)" : "translateY(12px)",
                transitionDelay: `${i * 90}ms`,
              }}
            >
              <span className="font-display text-[28px] md:text-[34px] leading-none tracking-[-0.02em] font-light text-white">
                {f.value}
              </span>
              <span className="text-[10px] md:text-[11px] tracking-[0.3em] uppercase text-white/55 mt-1 md:mt-0">
                {f.label}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}